import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=6dbf3ef1&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=6dbf3ef1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf3ef1",
  null
  
)

export default component.exports